import { styled } from "@mui/material/styles";
import { Container, Typography, Grid } from "@mui/material";

import ResponsiveImage from "components/ResponsiveImage";

export const Root = styled("div")(({ theme }) => ({
  width: "100%",
  position: "relative",
  background: "linear-gradient(0deg,#FABA61,#FF599B)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.up("mobile")]: {
    marginTop: 20,
  },
  [theme.breakpoints.up("tablet")]: {
    marginTop: 120,
  },
}));

export const Content = styled(Container)(({ theme }) => ({
  position: "relative",
  textAlign: "center",
  margin: "42px auto 58px auto",
  padding: 0,
  [theme.breakpoints.up("mobile")]: {
    margin: "55px auto 84px auto",
  },
  [theme.breakpoints.up("tablet")]: {
    margin: "96px auto 165px auto",
  },
}));

export const Paragraph = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  margin: "0 50px 12px 59px",
  [theme.breakpoints.up("mobile")]: {
    margin: "0 118px 12px 118px",
  },
  [theme.breakpoints.up("tablet")]: {
    margin: "0 198px 12px 195px",
  },
}));

export const GridContainer = styled(Grid)({
  marginTop: "auto",
});

export const StyledGrid = styled(Grid)(({ theme }) => ({
  height: 75,
  marginBottom: 18,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.up("mobile")]: {
    height: 160,
    marginBottom: 0,
  },
  [theme.breakpoints.up("tablet")]: {
    height: 283,
    marginBottom: 15,
  },
}));

export const Logo = styled(ResponsiveImage)(({ theme }) => ({
  width: 132,
  [theme.breakpoints.up("mobile")]: {
    width: 248,
  },
  [theme.breakpoints.up("tablet")]: {
    width: 501,
  },
}));
